/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable camelcase */
/* eslint-disable indent */
import React, { useMemo, useRef } from 'react';
import classnames from 'classnames';

import Link from 'components/atoms/Link';
import ProductLabelSet from 'components/molecules/ProductLabelSet';

import { useCart } from 'models/cart';
import { useMember } from 'models/member';
import { useHistory } from 'models/routing';
import { LineEventType, getProductIdForLineEvent, useLineEvent } from 'models/lineEvent';

import { ProductResource } from 'util/api/swaggerApi/data-contracts';
import { omniAddToOrRemovefromCart, omniEvent } from 'util/omniEvent';
import { gtmAddToOrRemovefromCart } from 'util/gtmEvent';
import { useProductStock } from 'util/hook/useProductStock';
import useMedia from 'util/hook/useMedia';
import { produceEventLabels } from 'util/produceEventLabels';
import pushHistory from 'util/pushHistory';
import thousands from 'util/thousands';

import AddToCartBtns from '../AddToCartBtns';

import styles from './index.module.css';

export interface ProductCardProperty extends ProductResource {
	className?: string;
	soldOut?: boolean;
	index?: number;
	pageName?: string;
	combination?: boolean;
	products?: number[];
}

const ProductCard: React.FC<ProductCardProperty> = ({
	className,
	id,
	name,
	materialNo,
	briefDescription,
	price,
	memberPrice,
	eventPrice,
	hashtag1,
	hashtag2,
	images,
	soldOut,
	index,
	pageName,
	combination = false,
	purchaseLimit,
	products,
	discounts,
}) => {
	const [{ cartData }, { storeCartProduct, removeCartProductById }] = useCart();
	const productType = combination ? 'combination' : 'normal';
	const [{ userInfo }] = useMember();
	const history = useHistory();
	const [, { triggerAddToCartByLineEvent }] = useLineEvent();

	const productStock = useProductStock(productType, id!, products);

	const refDiv = useRef<HTMLDivElement>(null);

	const productLabel = useMemo(
		() => [
			{
				text: hashtag1 || '',
			},
			{
				text: hashtag2 || '',
			},
		],
		[hashtag1, hashtag2],
	);

	const handleClickProduct = () => {
		const path = `/products/${id}${combination ? '?combination=true' : ''}`;
		pushHistory(history, path);
		omniEvent(null); // Clear the previous i13n object.
		// Omni Product Clicks
		omniEvent({
			action: 'ClickProduct',
			uid: userInfo.id ?? '', //  User ID is required if user has login
			p: pageName,
			products: [
				{
					name, // Name is required.
					id: materialNo, // ID is required.
					price: eventPrice || memberPrice,
					brand: '愛康生技',
					variant: briefDescription,
					position: index,
				},
			],
		});
	};

	// Omni Add / Remove from Cart
	const handleAddToOrRemovefromCart = (number: number) => {
		omniAddToOrRemovefromCart(
			number,
			name,
			materialNo,
			eventPrice,
			memberPrice,
			briefDescription,
			userInfo.id,
		);
		gtmAddToOrRemovefromCart(number, name, materialNo, eventPrice, memberPrice, briefDescription);
		triggerAddToCartByLineEvent([
			{
				product_id: getProductIdForLineEvent(materialNo || '', combination),
				product_name: name || '',
				product_type: LineEventType.NORMAL,
				product_amount: eventPrice || memberPrice || price || 0,
			},
		]);
	};

	const handleAddToCartSubmit = (count: number, diff: number) => {
		storeCartProduct(id!, count, combination);
		handleAddToOrRemovefromCart(diff);
		if (count === 0) {
			removeCartProductById(id!, combination);
		}
	};

	const media = useMedia();

	return (
		<div className={classnames(styles.productCard, className)} ref={refDiv}>
			<Link className={styles.imgContainer} onClick={handleClickProduct}>
				<img src={images?.length ? images[0] : ''} alt="product" />
				<ProductLabelSet
					labelData={
						soldOut || productStock === 0
							? [
									{
										text: '售完',
										backgroundColor: '#999',
									},
							  ]
							: produceEventLabels(media, 'card', discounts, eventPrice)
					}
					className={styles.eventLabel}
					direction="column"
				/>
			</Link>
			<div className={styles.productLabelSet}>
				<ProductLabelSet labelData={productLabel} className={styles.productLabel} />
			</div>
			<h2 onClick={handleClickProduct}>{name}</h2>

			<p className={styles.description}>{briefDescription}</p>

			<div className={classnames(styles.price, eventPrice && styles.marketPrice)}>
				<h3 className={eventPrice ? styles.special : styles.market}>
					<span>$</span>
					{thousands(eventPrice) || thousands(memberPrice)}
				</h3>
				<p className={styles.original}>市價 ${thousands(price)}</p>
			</div>
			<AddToCartBtns
				className={styles.addToCartBtns}
				productQuantityinCart={cartData ? cartData[productType][String(id)] || 0 : 0}
				disabled={soldOut}
				direction="column"
				handleAddToCartSubmit={handleAddToCartSubmit}
				max={Math.min(purchaseLimit || Number.MAX_SAFE_INTEGER, productStock)}
			/>
		</div>
	);
};

export default ProductCard;
